import { Component, OnInit, Inject } from '@angular/core';

import { FinanzasService } from 'app/finanzas/finanzas.service';

import { Dependencia, Subdependencia,  Usuario, ComprobanteE, Areas, TiposCE } from 'app/finanzas/entidades';

import { isNumber } from 'util';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-form-comprobante',
  templateUrl: './form-comprobante.component.html',
  styleUrls: ['./form-comprobante.component.css']
})
export class FormComprobanteComponent implements OnInit {

  comprobante : ComprobanteE = new ComprobanteE();
  subdependencia : Number;
  dependencia :  Number;
  area : Number;

  tipos : TiposCE ;   // Trae la tabla finanzasTipoComprobantes de la bd 
  
  dependencias : Array<Dependencia>;  
  subdependencias : Array<Subdependencia>;
  usuarios :Array<Usuario>;

  // asignacion de lo que recibe del modal 
  areas : Array<Areas> = this.datos.areas;  
  comprobantes  = this.datos.comprobantes;
  

  constructor( private servicios:FinanzasService, 
              public dialogRef:MatDialogRef<FormComprobanteComponent>, 
              @Inject(MAT_DIALOG_DATA) private datos,
              ) {
                this.comprobante['mes']=this.datos.mes;
                this.comprobante['anio']=this.datos.anio;
                this.comprobante['empresa']=this.datos.empresa;
              }

  ngOnInit() {
    this.getTipoComprobantes()

    if(this.buscarId(this.datos.idComprobante)){
      this.servicios.ComprobanteId(this.datos.idComprobante)
      .subscribe(  ( [resp]:Array<ComprobanteE> ) => {    
          this.comprobante = resp; 
      })
    }
  }
    
  buscarId( idComprobante ){  
    return this.comprobantes.find(element => element.idComprobante ==  idComprobante);  
  }

  getTipoComprobantes(){
    this.servicios.tipoComprobante().
      subscribe(  ( resp : TiposCE)  => {
        this.tipos = resp
    })
  }


  // funciones si aplica dependencia
  public buscarDependencias():void{
    this.area = this.comprobante["area"]
    this.servicios.getDependencias(this.comprobante["area"])
      .subscribe( (resp : Array<Dependencia>) => {this.dependencias=resp} )
  }

  public buscarSubdependencias():void{
    this.dependencia = this.comprobante["dependencia"];
    this.servicios.getSubdependencias(this.comprobante["dependencia"]).subscribe( (resp: Array<Subdependencia>) => {this.subdependencias=resp; } )
  }

  public buscarUsuarios(): void {
    const selectedSubdependencia = this.comprobante['subdependencia'];
    
    // filtar usuarios dependendiendo el numero de argumentos que tenga
      // si no se pasa subdependencia
    if( !isNumber(selectedSubdependencia))  {
      // se consulta con area y dependencia
      this.servicios.getUsuarios_filter(this.area, this.dependencia  )
      .subscribe( (resp : Array<Usuario>   )   => {
        this.usuarios = resp;
        
      }); 
    }
    else { 
      this.servicios.getUsuarios( this.area, this.dependencia, selectedSubdependencia)
      .subscribe( (resp: Array<Usuario>) => {
        this.usuarios = resp;     
        
      });
    }  

  }
}
